/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * Сервис помещений
 */

/**
 * Сервис управления доступом пользователей
 */
export class AccessControlServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения Квартиры.
   * Метод доступен для: admin, service, ltp_first, owner, employee
   */
  GetRoom = (req: GetRoomRequestDto, init?: RequestInit): Promise<GetRoomResponseDto> => {
    return fm.request<GetRoomRequestDto, GetRoomResponseDto>(`${this.host}/access_control/api/v1/room/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка квартир.
   * Метод доступен для: admin, service, ltp_first, owner, employee, bti
   */
  GetRoomList = (req?: GetRoomListRequestDto, init?: RequestInit): Promise<GetRoomListResponseDto[]> => {
    return fm.list<GetRoomListRequestDto, GetRoomListResponseDto>(`${this.host}/access_control/api/v1/room/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества квартир.
   * Метод доступен для: admin, service, ltp_first, owner, employee, bti
   */
  GetRoomCount = (req?: GetRoomCountRequestDto, init?: RequestInit): Promise<GetRoomCountResponseDto> => {
    return fm.request<GetRoomCountRequestDto, GetRoomCountResponseDto>(`${this.host}/access_control/api/v1/room/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод установки режима подписок.
   * Метод доступен для: admin, service
   */
  PatchRoomSetSubscriptionMode = (req: PatchRoomSetSubscriptionModeRequestDto, init?: RequestInit): Promise<PatchRoomSetSubscriptionModeResponseDto> => {
    return fm.request<PatchRoomSetSubscriptionModeRequestDto, PatchRoomSetSubscriptionModeResponseDto>(`${this.host}/access_control/api/v1/room/set_subscription_mode`, { ...init, method: "PATCH", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод проверки существования квартиры по ОРПОН и её номеру.
   * Возвращает true если найдена квартира с указанными параметрами.
   * Метод доступен для: admin, service
   */
  GetRoomOrponNumberExists = (req: GetRoomOrponNumberExistsRequestDto, init?: RequestInit): Promise<GetRoomOrponNumberExistsResponseDto> => {
    return fm.request<GetRoomOrponNumberExistsRequestDto, GetRoomOrponNumberExistsResponseDto>(`${this.host}/access_control/api/v1/room/orpon/${encodeURIComponent(req.orpon)}/number/${encodeURIComponent(req.roomNumber)}/exists${fm.buildQuery(req, ["orpon","roomNumber"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник значений режимов подписки
 */
export enum PatchRoomSetSubscriptionModeRequestModeType {
  /**
   * Значение не указано
   */
  MODE_TYPE_UNKNOWN = "MODE_TYPE_UNKNOWN",
  /**
   * Выключено
   */
  DISABLED = "DISABLED",
  /**
   * Включено
   */
  ENABLED = "ENABLED",
}
/**
 * Справочник значений режимов подписки
 */
export type PatchRoomSetSubscriptionModeRequestModeTypeResponseEnum = keyof typeof PatchRoomSetSubscriptionModeRequestModeType
/**
 * Справочник значений режимов подписки
 */
export type PatchRoomSetSubscriptionModeRequestModeTypeRequestEnum = Exclude<PatchRoomSetSubscriptionModeRequestModeTypeResponseEnum, "MODE_TYPE_UNKNOWN">;

/**
 * Тип
 */
export enum RoomType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Этаж
   */
  FLOOR = "FLOOR",
  /**
   * Подъезд
   */
  ENTRANCE = "ENTRANCE",
  /**
   * Апартаменты
   */
  APARTMENT = "APARTMENT",
  /**
   * Вводно-распределительные устройства
   */
  WATER_DISTRIBUTION = "WATER_DISTRIBUTION",
  /**
   * Индивидуальный тепловой пункт
   */
  HEAT_POINT = "HEAT_POINT",
  /**
   * Кладовая
   */
  PANTRY = "PANTRY",
  /**
   * Колясочная
   */
  WHEELCHAIR = "WHEELCHAIR",
  /**
   * Коммутационный шкаф
   */
  WIRING_CLOSET = "WIRING_CLOSET",
  /**
   * Консьержная
   */
  CONCIERGE = "CONCIERGE",
  /**
   * КПП
   */
  CHECKPOINT = "CHECKPOINT",
  /**
   * Машиноместо
   */
  PARKING_PLACE = "PARKING_PLACE",
  /**
   * Офис
   */
  OFFICE = "OFFICE",
  /**
   * Подвал
   */
  BASEMENT = "BASEMENT",
  /**
   * Подстанция
   */
  SUBSTATION = "SUBSTATION",
  /**
   * Помещение правления ТСЖ
   */
  HOMEOWNERS_ROOM = "HOMEOWNERS_ROOM",
  /**
   * Тамбур
   */
  TAMBOUR = "TAMBOUR",
  /**
   * Узел ввода
   */
  INPUT_NODE = "INPUT_NODE",
  /**
   * Лобби
   */
  LOBBY = "LOBBY",
  /**
   * Чердак
   */
  ATTIC = "ATTIC",
  /**
   * Шахта лифта
   */
  ELEVATOR_SHAFT = "ELEVATOR_SHAFT",
  /**
   * Электрощитовая
   */
  SWITCHBOARD = "SWITCHBOARD",
  /**
   * Квартира по умолчанию
   */
  DEFAULT_ROOM = "DEFAULT_ROOM",
}
/**
 * Тип
 */
export type RoomTypeResponseEnum = keyof typeof RoomType
/**
 * Тип
 */
export type RoomTypeRequestEnum = Exclude<RoomTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum RoomPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type RoomPagingDirectionTypeResponseEnum = keyof typeof RoomPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type RoomPagingDirectionTypeRequestEnum = Exclude<RoomPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum RoomPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По времени создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По этажу и номеру
   */
  FLOOR_THEN_NUMBER = "FLOOR_THEN_NUMBER",
  /**
   * По номеру
   */
  NUMBER = "NUMBER",
}
/**
 * Справочник типов значений сортировки.
 */
export type RoomPagingOrderByTypeResponseEnum = keyof typeof RoomPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type RoomPagingOrderByTypeRequestEnum = Exclude<RoomPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Запрос получения количества квартир
 */
export type GetRoomCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: RoomFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества квартир
 */
export type GetRoomCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Количество
   */
  readonly data: number
}>
/**
 * Запрос получения списка квартир
 */
export type GetRoomListRequestDto = {
  /**
   * Фильтр
   */
  filter?: RoomFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: RoomPagingRequestDto
}>
/**
 * Ответ на запрос получения списка квартир
 */
export type GetRoomListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Квартира
   */
  readonly data: RoomResponseDto
  /**
   * Ошибка
   */
  readonly error: GetRoomListResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetRoomListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetRoomListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос проверки существования квартиры по ОРПОН и её номеру
 */
export type GetRoomOrponNumberExistsRequestDto = {
  /**
   * ОРПОН дома.
   * # Диапазон: 1..9223372036854775807
   */
  orpon: string
  /**
   * Номер квартиры.
   * # Диапазон: 1..4
   */
  roomNumber: string
}
/**
 * Ответ на запрос проверки существования квартиры
 */
export type GetRoomOrponNumberExistsResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Результат проверки: true - если квартира существует, false - в противном случае
   */
  readonly data: boolean
  /**
   * Ошибка
   */
  readonly error: GetRoomOrponNumberExistsResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetRoomOrponNumberExistsResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetRoomOrponNumberExistsResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос получения квартиры
 */
export type GetRoomRequestDto = {
  /**
   * Идентификатор квартиры
   */
  id: number
}
/**
 * Ответ на запрос получения квартиры
 */
export type GetRoomResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Квартира
   */
  readonly data: RoomResponseDto
  /**
   * Ошибка
   */
  readonly error: GetRoomResponseErrorDto
}>
/**
 * Ошибка
 */
export type GetRoomResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetRoomResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Запрос на установку режима подписок
 */
export type PatchRoomSetSubscriptionModeRequestDto = {
  /**
   * Список идентификаторов МРФ
   */
  mrfIds?: number[]
  /**
   * Список идентификаторов РФ
   */
  rfIds?: number[]
  /**
   * Идентификатор ОРПОН дома
   */
  orponId?: string
  /**
   * Список номеров квартир
   */
  roomNumbers?: string[]
  /**
   * Значение режима подписок
   */
  modeType: PatchRoomSetSubscriptionModeRequestModeTypeRequestEnum
}
/**
 * Ответ на запрос на установку режима подписок
 */
export type PatchRoomSetSubscriptionModeResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PatchRoomSetSubscriptionModeResponseErrorDto
}>
/**
 * Ошибка
 */
export type PatchRoomSetSubscriptionModeResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Не передано значение ОРПОН
   */
  readonly orponExpected: PatchRoomSetSubscriptionModeResponseErrorOrponExpectedRequestDto
  /**
   * Не передан хотя бы один идентификатор
   */
  readonly idExpected: PatchRoomSetSubscriptionModeResponseErrorIdExpectedRequestDto
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type PatchRoomSetSubscriptionModeResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Не передано значение ОРПОН
   */
  readonly orponExpected: PatchRoomSetSubscriptionModeResponseErrorOrponExpectedDto
  /**
   * Не передан хотя бы один идентификатор
   */
  readonly idExpected: PatchRoomSetSubscriptionModeResponseErrorIdExpectedDto
  /**
   * Ошибка валидации
   */
  readonly validation: ValidationErrorResponseDto
}>
/**
 * Не передан хотя бы один идентификатор:
 * - Должен быть передан хотя бы один из параметров:
 *  - mrf_ids;
 *  - rf_ids;
 *  - opron_id
 */
export type PatchRoomSetSubscriptionModeResponseErrorIdExpectedRequestDto = {
}
/**
 * Не передан хотя бы один идентификатор:
 * - Должен быть передан хотя бы один из параметров:
 *  - mrf_ids;
 *  - rf_ids;
 *  - opron_id
 */
export type PatchRoomSetSubscriptionModeResponseErrorIdExpectedDto = {
}
/**
 * Не передано значение ОРПОН:
 * - Если переданы номера квартир, то значение параметра ОРПОН обязательно
 */
export type PatchRoomSetSubscriptionModeResponseErrorOrponExpectedRequestDto = {
}
/**
 * Не передано значение ОРПОН:
 * - Если переданы номера квартир, то значение параметра ОРПОН обязательно
 */
export type PatchRoomSetSubscriptionModeResponseErrorOrponExpectedDto = {
}
/**
 * Квартира
 */
export type RoomRequestDto = {
  /**
   * Идентификатор квартиры
   */
  id: number
  /**
   * Номер
   */
  number: string
  /**
   * Подъезд
   */
  entrance: number
  /**
   * Этаж
   */
  floor: number
  /**
   * Площадь
   */
  area?: number
  /**
   * Идентификатор дома
   */
  buildingId: number
  /**
   * Идентификатор компании
   */
  companyId: number
  /**
   * Номер абонента
   */
  abonentId: string
  /**
   * Тип
   */
  type: RoomTypeRequestEnum
}
/**
 * Квартира
 */
export type RoomResponseDto = {
  /**
   * Идентификатор квартиры
   */
  id: number
  /**
   * Номер
   */
  number: string
  /**
   * Подъезд
   */
  entrance: number
  /**
   * Этаж
   */
  floor: number
  /**
   * Площадь
   */
  area: number
  /**
   * Идентификатор дома
   */
  buildingId: number
  /**
   * Идентификатор компании
   */
  companyId: number
  /**
   * Номер абонента
   */
  abonentId: string
  /**
   * Тип
   */
  type: RoomTypeResponseEnum
  /**
   * Дата создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата удаления.
   * # Тип: DateTime
   */
  readonly deletedAt: string | null
  /**
   * Включен ли режим подписок
   */
  readonly isSubscriptionModeEnabled: boolean
}
/**
 * Фильтр по квартирам
 */
export type RoomFilterRequestDto = {
  /**
   * По идентификаторам домов
   */
  buildingIds?: number[]
  /**
   * По подъездам
   */
  entrances?: number[]
  /**
   * По этажам
   */
  floors?: number[]
  /**
   * По идентификаторам компаний
   */
  companyIds?: number[]
  /**
   * По типам
   */
  types?: RoomTypeResponseEnum[]
  /**
   * По идентификаторам устройств
   */
  deviceIds?: number[]
  /**
   * По ОРПОНам
   */
  orpons?: string[]
  /**
   * По признаку служебной квартиры
   */
  isServiceFlag?: boolean | null
  /**
   * По номерам квартир
   */
  roomNumbers?: string[]
}
/**
 * Фильтр по квартирам
 */
export type RoomFilterResponseDto = {
  /**
   * По идентификаторам домов
   */
  buildingIds: number[]
  /**
   * По подъездам
   */
  entrances: number[]
  /**
   * По этажам
   */
  floors: number[]
  /**
   * По идентификаторам компаний
   */
  companyIds: number[]
  /**
   * По типам
   */
  types: RoomTypeResponseEnum[]
  /**
   * По идентификаторам устройств
   */
  deviceIds: number[]
  /**
   * По ОРПОНам
   */
  orpons: string[]
  /**
   * По признаку служебной квартиры
   */
  isServiceFlag: boolean | null
  /**
   * По номерам квартир
   */
  roomNumbers: string[]
}
/**
 * Постраничный вывод
 */
export type RoomPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CREATED_AT
   */
  orderByType?: RoomPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: RoomPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type RoomPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CREATED_AT
   */
  orderByType: RoomPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: RoomPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorRequestDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Ошибки валидации.
 * Эти проверки выполняются до обращения в базу данных
 */
export type ValidationErrorResponseDto = {
  /**
   * Путь к полю в формате наименования прото
   */
  path: string
  /**
   * Валидационное сообщение
   */
  message: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос получения количества квартир
   */
  "GetRoomCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества квартир",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "RoomFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества квартир
   */
  "GetRoomCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества квартир",
    "fields": {
      /**
       * Количество
       */
      "data": {
        "type": "int32",
        "text": "Количество",
      },
    },
  },
  /**
   * Запрос получения списка квартир
   */
  "GetRoomListRequest": {
    "kind": "class",
    "text": "Запрос получения списка квартир",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "RoomFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "RoomPaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос получения списка квартир
   */
  "GetRoomListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка квартир",
    "fields": {
      /**
       * Квартира
       */
      "data": {
        "type": "Room",
        "text": "Квартира",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetRoomListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetRoomListResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос проверки существования квартиры по ОРПОН и её номеру
   */
  "GetRoomOrponNumberExistsRequest": {
    "kind": "class",
    "text": "Запрос проверки существования квартиры по ОРПОН и её номеру",
    "fields": {
      /**
       * ОРПОН дома.
       * # Диапазон: 1..9223372036854775807
       */
      "orpon": {
        "type": "int64",
        "text": "ОРПОН дома.\n# Диапазон: 1..9223372036854775807",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 9223372036854775807,
            "message": "Значение не входит в допустимый диапазон. Максимум: 9223372036854775807"
          },
        }
      },
      /**
       * Номер квартиры.
       * # Диапазон: 1..4
       */
      "roomNumber": {
        "type": "string",
        "text": "Номер квартиры.\n# Диапазон: 1..4",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "minLength": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "maxLength": {
            "value": 4,
            "message": "Значение не входит в допустимый диапазон. Максимум: 4"
          },
        }
      },
    },
  },
  /**
   * Ответ на запрос проверки существования квартиры
   */
  "GetRoomOrponNumberExistsResponse": {
    "kind": "class",
    "text": "Ответ на запрос проверки существования квартиры",
    "fields": {
      /**
       * Результат проверки: true - если квартира существует, false - в противном случае
       */
      "data": {
        "type": "bool",
        "text": "Результат проверки: true - если квартира существует, false - в противном случае",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetRoomOrponNumberExistsResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetRoomOrponNumberExistsResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения квартиры
   */
  "GetRoomRequest": {
    "kind": "class",
    "text": "Запрос получения квартиры",
    "fields": {
      /**
       * Идентификатор квартиры
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения квартиры
   */
  "GetRoomResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения квартиры",
    "fields": {
      /**
       * Квартира
       */
      "data": {
        "type": "Room",
        "text": "Квартира",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetRoomResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetRoomResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на установку режима подписок
   */
  "PatchRoomSetSubscriptionModeRequest": {
    "kind": "class",
    "text": "Запрос на установку режима подписок",
    "fields": {
      /**
       * Список идентификаторов МРФ
       */
      "mrfIds": {
        "type": "int32",
        "text": "Список идентификаторов МРФ",
      },
      /**
       * Список идентификаторов РФ
       */
      "rfIds": {
        "type": "int32",
        "text": "Список идентификаторов РФ",
      },
      /**
       * Идентификатор ОРПОН дома
       */
      "orponId": {
        "type": "int64",
        "text": "Идентификатор ОРПОН дома",
      },
      /**
       * Список номеров квартир
       */
      "roomNumbers": {
        "type": "string",
        "text": "Список номеров квартир",
      },
      /**
       * Значение режима подписок
       */
      "modeType": {
        "type": "PatchRoomSetSubscriptionModeRequest.ModeType",
        "text": "Значение режима подписок",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на установку режима подписок
   */
  "PatchRoomSetSubscriptionModeResponse": {
    "kind": "class",
    "text": "Ответ на запрос на установку режима подписок",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PatchRoomSetSubscriptionModeResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка
   */
  "PatchRoomSetSubscriptionModeResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Не передано значение ОРПОН
       */
      "orponExpected": {
        "type": "PatchRoomSetSubscriptionModeResponse.Error.OrponExpected",
        "text": "Не передано значение ОРПОН",
      },
      /**
       * Не передан хотя бы один идентификатор
       */
      "idExpected": {
        "type": "PatchRoomSetSubscriptionModeResponse.Error.IdExpected",
        "text": "Не передан хотя бы один идентификатор",
      },
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Не передан хотя бы один идентификатор:
   * - Должен быть передан хотя бы один из параметров:
   *  - mrf_ids;
   *  - rf_ids;
   *  - opron_id
   */
  "PatchRoomSetSubscriptionModeResponse.Error.IdExpected": {
    "kind": "class",
    "text": "Не передан хотя бы один идентификатор:\n- Должен быть передан хотя бы один из параметров:\n - mrf_ids;\n - rf_ids;\n - opron_id",
  },
  /**
   * Не передано значение ОРПОН:
   * - Если переданы номера квартир, то значение параметра ОРПОН обязательно
   */
  "PatchRoomSetSubscriptionModeResponse.Error.OrponExpected": {
    "kind": "class",
    "text": "Не передано значение ОРПОН:\n- Если переданы номера квартир, то значение параметра ОРПОН обязательно",
  },
  /**
   * Квартира
   */
  "Room": {
    "kind": "class",
    "text": "Квартира",
    "fields": {
      /**
       * Идентификатор квартиры
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор квартиры",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер
       */
      "number": {
        "type": "string",
        "text": "Номер",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Подъезд
       */
      "entrance": {
        "type": "int32",
        "text": "Подъезд",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Этаж
       */
      "floor": {
        "type": "int32",
        "text": "Этаж",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Площадь
       */
      "area": {
        "type": "float",
        "text": "Площадь",
      },
      /**
       * Идентификатор дома
       */
      "buildingId": {
        "type": "int32",
        "text": "Идентификатор дома",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор компании
       */
      "companyId": {
        "type": "int32",
        "text": "Идентификатор компании",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Номер абонента
       */
      "abonentId": {
        "type": "string",
        "text": "Номер абонента",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип
       */
      "type": {
        "type": "Room.Type",
        "text": "Тип",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Дата создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата создания.\n# Тип: DateTime",
      },
      /**
       * Дата удаления.
       * # Тип: DateTime
       */
      "deletedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата удаления.\n# Тип: DateTime",
      },
      /**
       * Включен ли режим подписок
       */
      "isSubscriptionModeEnabled": {
        "type": "bool",
        "text": "Включен ли режим подписок",
      },
    },
  },
  /**
   * Фильтр по квартирам
   */
  "RoomFilter": {
    "kind": "class",
    "text": "Фильтр по квартирам",
    "fields": {
      /**
       * По идентификаторам домов
       */
      "buildingIds": {
        "type": "int32",
        "text": "По идентификаторам домов",
      },
      /**
       * По подъездам
       */
      "entrances": {
        "type": "int32",
        "text": "По подъездам",
      },
      /**
       * По этажам
       */
      "floors": {
        "type": "int32",
        "text": "По этажам",
      },
      /**
       * По идентификаторам компаний
       */
      "companyIds": {
        "type": "int32",
        "text": "По идентификаторам компаний",
      },
      /**
       * По типам
       */
      "types": {
        "type": "Room.Type",
        "text": "По типам",
      },
      /**
       * По идентификаторам устройств
       */
      "deviceIds": {
        "type": "int32",
        "text": "По идентификаторам устройств",
      },
      /**
       * По ОРПОНам
       */
      "orpons": {
        "type": "int64",
        "text": "По ОРПОНам",
      },
      /**
       * По признаку служебной квартиры
       */
      "isServiceFlag": {
        "type": "google.protobuf.BoolValue",
        "text": "По признаку служебной квартиры",
      },
      /**
       * По номерам квартир
       */
      "roomNumbers": {
        "type": "string",
        "text": "По номерам квартир",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "RoomPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CREATED_AT
       */
      "orderByType": {
        "type": "RoomPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CREATED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "RoomPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Ошибки валидации.
   * Эти проверки выполняются до обращения в базу данных
   */
  "ValidationError": {
    "kind": "class",
    "text": "Ошибки валидации.\nЭти проверки выполняются до обращения в базу данных",
    "fields": {
      /**
       * Путь к полю в формате наименования прото
       */
      "path": {
        "type": "string",
        "text": "Путь к полю в формате наименования прото",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Валидационное сообщение
       */
      "message": {
        "type": "string",
        "text": "Валидационное сообщение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Справочник значений режимов подписки
   */
  "PatchRoomSetSubscriptionModeRequest.ModeType": {
    "kind": "enum",
    "text": "Справочник значений режимов подписки",
    "values": {
      /**
       * Значение не указано
       */
      "MODE_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Выключено
       */
      "DISABLED": {
        "i": 1,
        "text": "Выключено",
      },
      /**
       * Включено
       */
      "ENABLED": {
        "i": 2,
        "text": "Включено",
      },
    },
  },
  /**
   * Тип
   */
  "Room.Type": {
    "kind": "enum",
    "text": "Тип",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Этаж
       */
      "FLOOR": {
        "i": 1,
        "text": "Этаж",
      },
      /**
       * Подъезд
       */
      "ENTRANCE": {
        "i": 2,
        "text": "Подъезд",
      },
      /**
       * Апартаменты
       */
      "APARTMENT": {
        "i": 3,
        "text": "Апартаменты",
      },
      /**
       * Вводно-распределительные устройства
       */
      "WATER_DISTRIBUTION": {
        "i": 4,
        "text": "Вводно-распределительные устройства",
      },
      /**
       * Индивидуальный тепловой пункт
       */
      "HEAT_POINT": {
        "i": 5,
        "text": "Индивидуальный тепловой пункт",
      },
      /**
       * Кладовая
       */
      "PANTRY": {
        "i": 6,
        "text": "Кладовая",
      },
      /**
       * Колясочная
       */
      "WHEELCHAIR": {
        "i": 7,
        "text": "Колясочная",
      },
      /**
       * Коммутационный шкаф
       */
      "WIRING_CLOSET": {
        "i": 8,
        "text": "Коммутационный шкаф",
      },
      /**
       * Консьержная
       */
      "CONCIERGE": {
        "i": 9,
        "text": "Консьержная",
      },
      /**
       * КПП
       */
      "CHECKPOINT": {
        "i": 10,
        "text": "КПП",
      },
      /**
       * Машиноместо
       */
      "PARKING_PLACE": {
        "i": 11,
        "text": "Машиноместо",
      },
      /**
       * Офис
       */
      "OFFICE": {
        "i": 12,
        "text": "Офис",
      },
      /**
       * Подвал
       */
      "BASEMENT": {
        "i": 13,
        "text": "Подвал",
      },
      /**
       * Подстанция
       */
      "SUBSTATION": {
        "i": 14,
        "text": "Подстанция",
      },
      /**
       * Помещение правления ТСЖ
       */
      "HOMEOWNERS_ROOM": {
        "i": 15,
        "text": "Помещение правления ТСЖ",
      },
      /**
       * Тамбур
       */
      "TAMBOUR": {
        "i": 16,
        "text": "Тамбур",
      },
      /**
       * Узел ввода
       */
      "INPUT_NODE": {
        "i": 17,
        "text": "Узел ввода",
      },
      /**
       * Лобби
       */
      "LOBBY": {
        "i": 18,
        "text": "Лобби",
      },
      /**
       * Чердак
       */
      "ATTIC": {
        "i": 19,
        "text": "Чердак",
      },
      /**
       * Шахта лифта
       */
      "ELEVATOR_SHAFT": {
        "i": 20,
        "text": "Шахта лифта",
      },
      /**
       * Электрощитовая
       */
      "SWITCHBOARD": {
        "i": 21,
        "text": "Электрощитовая",
      },
      /**
       * Квартира по умолчанию
       */
      "DEFAULT_ROOM": {
        "i": 22,
        "text": "Квартира по умолчанию",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "RoomPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "RoomPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По времени создания
       */
      "CREATED_AT": {
        "i": 2,
        "text": "По времени создания",
      },
      /**
       * По этажу и номеру
       */
      "FLOOR_THEN_NUMBER": {
        "i": 3,
        "text": "По этажу и номеру",
      },
      /**
       * По номеру
       */
      "NUMBER": {
        "i": 4,
        "text": "По номеру",
      },
    },
  },
}